/**
 * Ghost Films - Dynamic Product Cut-Down Option Controller
 * Handles conditional display (+ $30 fee) for PPF & Window Tint products.
 */
(function () {
  if (window.__GhostFilmsCutDownLoaded) return;
  window.__GhostFilmsCutDownLoaded = true;

  function is60InchTintSize(str) {
    if (!str) return false;
    const s = str.toString().trim().toLowerCase();

    // Rejection 1: Shades / VLT percentages (5%, 15%, 25%, 35%, 55%, 75%, 60%)
    if (/^\d+\s*%/i.test(s) || /^\d+\s*percent/i.test(s) || /shade/i.test(s)) {
      return false;
    }

    // Rejection 2: Other roll widths (40" X 100', 36" X 100', etc.)
    if (/^(20|24|30|36|40|50)\s*(["”]|inch|in\b|\s*x|\s*\*)/i.test(s)) {
      return false;
    }

    // Match 60" roll size (e.g. 60" X 100', 60"x100', 60" X 50', 60-inch, 60")
    return /60\s*(["”]|inch|in\b|\s*x|\s*\*)/i.test(s) || /\b60\b/i.test(s);
  }

  function is60x50PPFSize(str) {
    if (!str) return false;
    const s = str.toString().trim().toLowerCase().replace(/[“”″]/g, '"').replace(/[‘’′]/g, "'");

    // Quick rejection: must mention 60 and 50
    if (!s.includes('60') || !s.includes('50')) {
      return false;
    }

    // Rejection: Shades / VLT percentages (e.g. 50%, 60%)
    if (/^\d+\s*%/i.test(s) || /%\s*$/.test(s) || /shade/i.test(s)) {
      return false;
    }

    // Match 60" width and 50' length (e.g. 60" X 50', 60"x50', 60" X 50ft, 60 x 50, etc.)
    return /\b60\s*(["']|inch|in|-inch)?\s*(?:[x*×]|by|\/|\s)\s*50\s*(['"]|ft|feet|foot|-foot)?(?!\d)/i.test(s);
  }

  function isClearOrSatinColor(str) {
    if (!str) return false;
    const s = str.toString().trim().toLowerCase();
    return (
      s === 'clear gloss' ||
      s === 'clear' ||
      s === 'satin' ||
      s.includes('clear gloss') ||
      s.includes('clear') ||
      s.includes('satin')
    );
  }

  function formatMoney(cents) {
    const format = (window.MinimogSettings && window.MinimogSettings.money_format) || '${{amount}}';
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, format);
    }
    if (window.MinimogTheme && typeof window.MinimogTheme.formatMoney === 'function') {
      return window.MinimogTheme.formatMoney(cents, format);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function initCutDownFeature() {
    const cutWrappers = document.querySelectorAll('[data-cut-down-wrapper]');
    if (!cutWrappers.length) return;

    cutWrappers.forEach((wrapper) => {
      if (wrapper.dataset.initialized === 'true') return;
      wrapper.dataset.initialized = 'true';

      const productId = wrapper.dataset.productId;
      const cutRule = wrapper.dataset.cutRule; // 'ppf' or 'tint_60'
      const addonVariantId = wrapper.dataset.cutAddonId || '50529923596424';
      const cutFeeCents = parseInt(wrapper.dataset.cutFee || '5000', 10);
      const capSheetAddonId = wrapper.dataset.capSheetAddonId || '50532606836872';
      const capSheetFeeCents = parseInt(wrapper.dataset.capSheetFee || '5000', 10);
      const cutSelect = wrapper.querySelector('[data-cut-down-select]');
      const capSheetCheckbox = wrapper.querySelector('[data-cap-sheet-checkbox]');
      const cutNotice = wrapper.querySelector('[data-cut-notice]');

      let variants = [];
      const variantsJsonEl = wrapper.querySelector('[data-cut-variants-json]');
      if (variantsJsonEl) {
        try {
          variants = JSON.parse(variantsJsonEl.textContent);
        } catch (e) {
          console.error('[CutDown] Could not parse variants JSON', e);
        }
      }

      // Find the parent product container and form
      const productContainer = wrapper.closest('.sf-prod__info') || wrapper.closest('.sf-product-wrapper') || wrapper.closest('[data-section-type="product-page"]') || document;
      const productForm = wrapper.closest('form') || productContainer.querySelector('form[data-type="add-to-cart-form"]') || productContainer.querySelector('form[action*="/cart/add"]');

      let currentVariant = null;

      function getCurrentVariantId() {
        if (productForm) {
          const idInput = productForm.querySelector('input[name="id"]');
          if (idInput && idInput.value) {
            return parseInt(idInput.value, 10);
          }
        }
        if (wrapper.dataset.initialVariantId) {
          return parseInt(wrapper.dataset.initialVariantId, 10);
        }
        return variants.length ? variants[0].id : null;
      }

      function getVariantById(id) {
        if (!id || !variants.length) return null;
        return variants.find((v) => v.id === id) || null;
      }

      // Ensures all variant option pickers (e.g. Size AND Shade, or Color AND Size) have been selected
      function areAllOptionsSelected() {
        if (!currentVariant || !currentVariant.id) {
          return false;
        }

        if (productContainer) {
          const pickerFields = productContainer.querySelectorAll('[data-picker-field], .variant-picker__field');
          if (pickerFields.length > 0) {
            for (const field of pickerFields) {
              const type = field.dataset.pickerField;
              if (type === 'radio' || type === 'button' || type === 'color' || type === 'image') {
                const checked = field.querySelector('input:checked');
                if (!checked || !checked.value) {
                  return false;
                }
              } else if (type === 'select') {
                const sel = field.querySelector('select');
                if (!sel || !sel.value) {
                  return false;
                }
              }
            }
          }
        }

        if (variants && variants.length > 0) {
          const expectedOptionCount = (variants[0].options || []).length;
          if (expectedOptionCount > 0) {
            const currentOptionCount = (currentVariant.options || []).filter(
              (opt) => opt !== null && opt !== undefined && opt.toString().trim() !== ''
            ).length;
            if (currentOptionCount < expectedOptionCount) {
              return false;
            }
          }
        }

        return true;
      }

      function checkEligibility(variant) {
        // Requirement: Show Cut-Down option only as the FINAL selection when all options are chosen
        if (!areAllOptionsSelected()) {
          return false;
        }

        if (!variant) return false;

        const title = (variant.title || '').toLowerCase();
        const options = (variant.options || []).map((opt) => (opt || '').toString());

        if (cutRule === 'ppf') {
          // Rule: PPF only shows when:
          // 1. First check: Selected size is 60" X 50'
          // 2. Second check: Selected color/finish is "Clear" or "Satin" (including "Clear Gloss")

          // --- Step 1: Check Size 60" X 50' ---
          let has60x50Size = options.some((opt) => is60x50PPFSize(opt));

          if (!has60x50Size && productContainer) {
            // Check Size picker elements in DOM
            const sizePickers = productContainer.querySelectorAll('[data-picker-field], .variant-picker__field');
            for (const picker of sizePickers) {
              const name = (picker.dataset.optionName || '').toLowerCase();
              if (name.includes('size') || name.includes('dimension') || name.includes('width') || name.includes('length')) {
                const checked = picker.querySelector('input:checked');
                if (checked && is60x50PPFSize(checked.value)) {
                  has60x50Size = true;
                  break;
                }
                const sel = picker.querySelector('select');
                if (sel && is60x50PPFSize(sel.value)) {
                  has60x50Size = true;
                  break;
                }
              }
            }

            if (!has60x50Size) {
              const selectedLabels = productContainer.querySelectorAll('.selected-value');
              for (const lbl of selectedLabels) {
                if (is60x50PPFSize(lbl.textContent)) {
                  has60x50Size = true;
                  break;
                }
              }
            }
          }

          if (!has60x50Size && is60x50PPFSize(title)) {
            has60x50Size = true;
          }

          // If size is NOT 60" X 50', reject immediately
          if (!has60x50Size) {
            return false;
          }

          // --- Step 2: Check Color ("Clear" or "Satin") ---
          let hasClearOrSatin = options.some((opt) => isClearOrSatinColor(opt));

          if (!hasClearOrSatin && productContainer) {
            // Check Color picker elements in DOM
            const colorPickers = productContainer.querySelectorAll('[data-picker-field], .variant-picker__field');
            for (const picker of colorPickers) {
              const name = (picker.dataset.optionName || '').toLowerCase();
              if (name.includes('color') || name.includes('colour') || name.includes('finish') || name.includes('type') || name.includes('shade')) {
                const checked = picker.querySelector('input:checked');
                if (checked && isClearOrSatinColor(checked.value)) {
                  hasClearOrSatin = true;
                  break;
                }
                const sel = picker.querySelector('select');
                if (sel && isClearOrSatinColor(sel.value)) {
                  hasClearOrSatin = true;
                  break;
                }
              }
            }

            if (!hasClearOrSatin) {
              const checkedSwatches = productContainer.querySelectorAll(
                '.variant-picker__option input:checked, [data-picker-field] input:checked'
              );
              for (const sw of checkedSwatches) {
                if (sw && sw.value && isClearOrSatinColor(sw.value)) {
                  hasClearOrSatin = true;
                  break;
                }
              }
            }

            if (!hasClearOrSatin) {
              const selectedLabels = productContainer.querySelectorAll('.selected-value');
              for (const lbl of selectedLabels) {
                if (isClearOrSatinColor(lbl.textContent)) {
                  hasClearOrSatin = true;
                  break;
                }
              }
            }
          }

          if (!hasClearOrSatin && isClearOrSatinColor(title)) {
            hasClearOrSatin = true;
          }

          return hasClearOrSatin;
        }

        if (cutRule === 'tint_60') {
          // Rule: Window Tint only shows when 60" roll size (e.g. 60" X 100') is selected AND shade is selected
          const has60SizeOption = options.some((opt) => is60InchTintSize(opt));
          if (has60SizeOption) return true;

          // DOM check for Size picker
          if (productContainer) {
            const sizePickers = productContainer.querySelectorAll('[data-picker-field], .variant-picker__field');
            for (const picker of sizePickers) {
              const name = (picker.dataset.optionName || '').toLowerCase();
              if (name.includes('size') || name.includes('dimension') || name.includes('width')) {
                const checked = picker.querySelector('input:checked');
                if (checked && is60InchTintSize(checked.value)) {
                  return true;
                }
              }
            }

            const selectedLabels = productContainer.querySelectorAll('.selected-value');
            for (const lbl of selectedLabels) {
              if (is60InchTintSize(lbl.textContent)) {
                return true;
              }
            }
          }

          return is60InchTintSize(title);
        }

        return false;
      }

      function updateDisplayPrice() {
        if (!currentVariant) return;

        const regularPriceEls = productContainer.querySelectorAll('.f-price-item--regular, .prod__regular_price');
        const salePriceEls = productContainer.querySelectorAll('.f-price-item--sale, .prod__price');

        const isCutSelected = cutSelect && cutSelect.value !== '';
        const isCapSheetSelected = capSheetCheckbox && capSheetCheckbox.checked;

        let addedFee = 0;
        if (isCutSelected) addedFee += cutFeeCents;
        if (isCapSheetSelected) addedFee += capSheetFeeCents;

        const basePrice = currentVariant.price;
        const targetPrice = basePrice + addedFee;
        const formattedPrice = formatMoney(targetPrice);

        salePriceEls.forEach((el) => {
          el.innerHTML = formattedPrice;
        });

        // If not on sale, also update regular price container
        if (!currentVariant.compare_at_price || currentVariant.compare_at_price <= currentVariant.price) {
          regularPriceEls.forEach((el) => {
            el.innerHTML = formattedPrice;
          });
        }
      }

      function updateUI() {
        const id = getCurrentVariantId();
        currentVariant = getVariantById(id);

        const eligible = checkEligibility(currentVariant);

        if (eligible) {
          wrapper.classList.remove('hidden');
          updateDisplayPrice();
          setTimeout(updateDisplayPrice, 30);
        } else {
          wrapper.classList.add('hidden');
          // Reset selection if variant is not eligible
          let changed = false;
          if (cutSelect && cutSelect.value !== '') {
            cutSelect.value = '';
            changed = true;
          }
          if (capSheetCheckbox && capSheetCheckbox.checked) {
            capSheetCheckbox.checked = false;
            changed = true;
          }
          if (changed) {
            handleOptionChange();
          }
        }
      }

      function handleOptionChange() {
        const isCutSelected = cutSelect && cutSelect.value !== '';
        const isCapSheetSelected = capSheetCheckbox && capSheetCheckbox.checked;

        if (cutNotice) {
          if (isCutSelected || isCapSheetSelected) {
            cutNotice.classList.remove('hidden');
            const textEl = cutNotice.querySelector('[data-cut-notice-text]') || cutNotice.querySelector('span:last-child');
            if (textEl) {
              if (isCutSelected && isCapSheetSelected) {
                textEl.textContent = '+$80.00 (Cut-Down & Cap Sheet Removal) fee will be added to your order.';
              } else if (isCutSelected) {
                textEl.textContent = '+$50.00 service fee will be added to your order.';
              } else if (isCapSheetSelected) {
                textEl.textContent = '+$50.00 cap sheet removal fee will be added to your order.';
              }
            }
          } else {
            cutNotice.classList.add('hidden');
          }
        }

        updateDisplayPrice();

        // Hide dynamic checkout button if cut or cap sheet is selected (dynamic checkout cannot bundle 2+ items)
        if (productForm) {
          const dynamicCheckouts = productForm.querySelectorAll('.prod__dynamic_checkout, .buy-one-click');
          dynamicCheckouts.forEach((btn) => {
            btn.style.display = (isCutSelected || isCapSheetSelected) ? 'none' : '';
          });
        }
      }

      let isSubmitting = false;

      // Intercept Add-to-Cart in CAPTURE phase so it takes precedence over Minimog theme handler
      const atcButton = productForm ? (productForm.querySelector('button[name="add"]') || productForm.querySelector('.add-to-cart')) : null;
      if (atcButton) {
        atcButton.addEventListener('click', async function (e) {
          const isCutVisible = !wrapper.classList.contains('hidden');
          const isCutSelected = cutSelect && cutSelect.value !== '';
          const isCapSheetSelected = capSheetCheckbox && capSheetCheckbox.checked;

          if (isCutVisible && (isCutSelected || isCapSheetSelected)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            await addCustomServicesToCart();
          }
        }, true);
      }

      if (productForm) {
        productForm.addEventListener(
          'submit',
          async function (e) {
            const isCutVisible = !wrapper.classList.contains('hidden');
            const isCutSelected = cutSelect && cutSelect.value !== '';
            const isCapSheetSelected = capSheetCheckbox && capSheetCheckbox.checked;

            if (isCutVisible && (isCutSelected || isCapSheetSelected)) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();

              await addCustomServicesToCart();
            }
          },
          true
        );
      }

      async function addCustomServicesToCart() {
        if (isSubmitting) return;
        isSubmitting = true;

        const atcBtn = productForm.querySelector('button[name="add"]') || productForm.querySelector('.add-to-cart');
        const formWrap = productForm.closest('.product-form') || productForm;

        // Button loading state
        if (atcBtn) {
          atcBtn.classList.add('sf-spinner-loading', 'disabled');
          atcBtn.setAttribute('disabled', 'disabled');
        }
        if (formWrap) {
          formWrap.classList.add('adding');
        }

        try {
          const qtyInput = productForm.querySelector('input[name="quantity"]');
          const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
          const isCutSelected = cutSelect && cutSelect.value !== '';
          const isCapSheetSelected = capSheetCheckbox && capSheetCheckbox.checked;
          const selectedCut = isCutSelected ? cutSelect.value : '';

          // Determine current variant safely
          let variantId = null;
          if (currentVariant && currentVariant.id) {
            variantId = currentVariant.id;
          } else {
            variantId = getCurrentVariantId();
          }
          if (!variantId && variants.length > 0) {
            variantId = variants[0].id;
          }
          if (!variantId) {
            throw new Error('No variant selected');
          }

          // Collect existing properties from form
          const rollProperties = {};
          const formData = new FormData(productForm);
          for (const [key, val] of formData.entries()) {
            const match = key.match(/^properties\[(.*?)\]$/);
            if (match && val && match[1] !== 'Cut-Down Size' && match[1] !== 'Cap Sheet Removal') {
              rollProperties[match[1]] = val;
            }
          }

          if (isCutSelected) {
            rollProperties['Cut-Down Size'] = selectedCut;
          }
          if (isCapSheetSelected) {
            rollProperties['Cap Sheet Removal'] = 'Yes (+$50.00)';
          }

          const prodName = (currentVariant && (currentVariant.name || currentVariant.title)) || 'PPF Roll';

          const items = [
            {
              id: Number(variantId),
              quantity: qty,
              properties: rollProperties
            }
          ];

          if (isCutSelected && addonVariantId && Number(addonVariantId)) {
            items.push({
              id: Number(addonVariantId),
              quantity: qty,
              properties: {
                '_Cut For Product': prodName,
                '_Cut Option': selectedCut
              }
            });
          }

          if (isCapSheetSelected && capSheetAddonId && Number(capSheetAddonId)) {
            items.push({
              id: Number(capSheetAddonId),
              quantity: qty,
              properties: {
                '_Cap Sheet For Product': prodName
              }
            });
          }

          const payload = { items };

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(payload)
          });

          const data = await res.json();

          if (data.status) {
            const errorMsg = data.description || data.message || 'Could not add to cart';
            const errorWrapper = productForm.querySelector('.prod__form-error') || document.body;
            if (window.MinimogTheme && window.MinimogTheme.Notification) {
              window.MinimogTheme.Notification.show({
                target: errorWrapper,
                method: 'appendChild',
                type: 'warning',
                message: errorMsg
              });
            } else {
              alert(errorMsg);
            }
            return;
          }

          // Trigger cart drawer refresh and open drawer
          const firstItem = (data.items && data.items.length) ? data.items[0] : data;
          const enableDrawer = window.MinimogSettings ? window.MinimogSettings.enable_cart_drawer : true;

          if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
            await window.Shopify.onItemAdded(firstItem, enableDrawer);
          } else if (window.MinimogTheme && window.MinimogTheme.Cart) {
            if (typeof window.MinimogTheme.Cart.refreshCart === 'function') {
              await window.MinimogTheme.Cart.refreshCart();
            }
            if (typeof window.MinimogTheme.Cart.renderNewCart === 'function') {
              await window.MinimogTheme.Cart.renderNewCart();
            }
            if (enableDrawer && typeof window.MinimogTheme.Cart.openCartDrawer === 'function') {
              window.MinimogTheme.Cart.openCartDrawer();
            }
            if (window.MinimogEvents) {
              window.MinimogEvents.emit('ON_ITEM_ADDED', firstItem);
            }
          } else {
            window.location.href = '/cart';
          }

          scheduleAdjustDrawerPrices(80);

        } catch (err) {
          console.error('[CutDown] Add to cart error:', err);
          if (window.MinimogTheme && window.MinimogTheme.Notification) {
            window.MinimogTheme.Notification.show({
              target: document.body,
              method: 'appendChild',
              type: 'warning',
              message: 'Could not add to cart. Please try again.'
            });
          }
        } finally {
          // ALWAYS RESET SPINNER & LOADING CLASSES
          if (atcBtn) {
            atcBtn.classList.remove('sf-spinner-loading', 'disabled');
            atcBtn.removeAttribute('disabled');
          }
          if (formWrap) {
            formWrap.classList.remove('adding');
          }
          isSubmitting = false;
        }
      }

      // Event Listeners
      if (cutSelect) {
        cutSelect.addEventListener('change', handleOptionChange);
      }
      if (capSheetCheckbox) {
        capSheetCheckbox.addEventListener('change', handleOptionChange);
      }

      // Variant change listener: Native input change (on form & variant picker container)
      if (productForm) {
        const idInput = productForm.querySelector('input[name="id"]');
        if (idInput) {
          idInput.addEventListener('change', updateUI);
        }
      }

      if (productContainer) {
        productContainer.addEventListener('change', (e) => {
          if (e.target.matches('input[name^="options"], select[name^="options"], [data-picker-field] input, [data-picker-field] select, .variant-picker__option input, [data-picker-field] input[type="radio"]')) {
            setTimeout(updateUI, 50);
          }
        });
      }

      // Variant change listener: Minimog Theme Event
      if (window.MinimogEvents && productId) {
        window.MinimogEvents.subscribe(`${productId}__VARIANT_CHANGE`, (variant) => {
          if (variant) {
            currentVariant = variant;
            const eligible = checkEligibility(currentVariant);
            if (eligible) {
              wrapper.classList.remove('hidden');
              updateDisplayPrice();
              setTimeout(updateDisplayPrice, 30);
            } else {
              wrapper.classList.add('hidden');
              let changed = false;
              if (cutSelect && cutSelect.value !== '') {
                cutSelect.value = '';
                changed = true;
              }
              if (capSheetCheckbox && capSheetCheckbox.checked) {
                capSheetCheckbox.checked = false;
                changed = true;
              }
              if (changed) {
                handleOptionChange();
              }
            }
          }
        });
      }

      // Initial check on page load
      updateUI();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCutDownFeature);
  } else {
    initCutDownFeature();
  }

  // Also re-init when sections re-render or dynamically loaded
  document.addEventListener('shopify:section:load', initCutDownFeature);
  document.addEventListener('theme:quickview:loaded', initCutDownFeature);

  /* =========================================================================
     CART SYNCHRONIZATION FOR HIDDEN SERVICE ADD-ONS (Cut: $30 & Cap Sheet: $50)
     - Keeps service add-on quantities in sync with customized rolls.
     - Removes service add-on if customer removes the customized roll.
     - Updates cart counter badges to exclude hidden service items.
     ========================================================================= */
  let isSyncingCart = false;

  function updateCartBadgeUI(count) {
    if (typeof count !== 'number' || isNaN(count)) return;
    const badges = document.querySelectorAll('.sf-cart-count');
    badges.forEach((b) => {
      b.textContent = count;
    });
  }

  function isAddonItem(item) {
    if (!item) return false;
    const vid = Number(item.variant_id);
    const pid = Number(item.product_id);
    if (
      vid === 50529923596424 ||
      pid === 10319994421384 ||
      vid === 50532606836872 ||
      pid === 10321079468168 ||
      item.handle === 'custom-roll-cut-service' ||
      item.handle === 'cap-sheet-removal'
    ) {
      return true;
    }
    if (item.properties) {
      if (item.properties['_Cut For Product'] || item.properties['_Cap Sheet For Product']) {
        return true;
      }
    }
    const title = (item.title || item.product_title || '').toLowerCase();
    if (title.includes('custom roll cut') || title.includes('cap sheet')) {
      return true;
    }
    return false;
  }

  async function syncCutAddonCart() {
    if (isSyncingCart) return;

    try {
      const res = await fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) return;
      const cart = await res.json();

      let requiredCutQty = 0;
      let requiredCapSheetQty = 0;

      (cart.items || []).forEach((item) => {
        // CRITICAL: NEVER count add-on service items themselves!
        if (isAddonItem(item)) {
          return;
        }

        if (item.properties) {
          let itemHasCut = false;
          let itemHasCapSheet = false;

          for (const [key, val] of Object.entries(item.properties)) {
            if (!val || key.startsWith('_')) continue;
            const k = key.toLowerCase();
            if (k.includes('cut-down') || k.includes('cut option') || k.includes('cut size')) {
              itemHasCut = true;
            }
            if (k.includes('cap sheet')) {
              itemHasCapSheet = true;
            }
          }

          if (itemHasCut) {
            requiredCutQty += item.quantity;
          }
          if (itemHasCapSheet) {
            requiredCapSheetQty += item.quantity;
          }
        }
      });

      const cutItems = (cart.items || []).filter(
        (item) =>
          item.variant_id === 50529923596424 ||
          item.product_id === 10319994421384 ||
          item.handle === 'custom-roll-cut-service' ||
          (item.properties && item.properties['_Cut For Product'])
      );

      const capSheetItems = (cart.items || []).filter(
        (item) =>
          item.variant_id === 50532606836872 ||
          item.product_id === 10321079468168 ||
          item.handle === 'cap-sheet-removal' ||
          (item.properties && item.properties['_Cap Sheet For Product'])
      );

      const currentCutQty = cutItems.reduce((acc, itm) => acc + itm.quantity, 0);
      const currentCapSheetQty = capSheetItems.reduce((acc, itm) => acc + itm.quantity, 0);

      // Update cart count badge to show actual customer items
      updateCartBadgeUI(Math.max(0, cart.item_count - currentCutQty - currentCapSheetQty));

      const needCutSync = currentCutQty !== requiredCutQty;
      const needCapSheetSync = currentCapSheetQty !== requiredCapSheetQty;

      if (!needCutSync && !needCapSheetSync) {
        return;
      }

      isSyncingCart = true;

      const updates = {};
      // Sync Cut Addon
      if (requiredCutQty === 0 && currentCutQty > 0) {
        cutItems.forEach((itm) => {
          updates[itm.key] = 0;
        });
      } else if (requiredCutQty > 0 && cutItems.length > 0) {
        updates[cutItems[0].key] = requiredCutQty;
        for (let i = 1; i < cutItems.length; i++) {
          updates[cutItems[i].key] = 0;
        }
      }

      // Sync Cap Sheet Addon
      if (requiredCapSheetQty === 0 && currentCapSheetQty > 0) {
        capSheetItems.forEach((itm) => {
          updates[itm.key] = 0;
        });
      } else if (requiredCapSheetQty > 0 && capSheetItems.length > 0) {
        updates[capSheetItems[0].key] = requiredCapSheetQty;
        for (let i = 1; i < capSheetItems.length; i++) {
          updates[capSheetItems[i].key] = 0;
        }
      }

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      // Re-render cart drawer
      if (window.MinimogTheme && window.MinimogTheme.Cart && typeof window.MinimogTheme.Cart.fetchCartSection === 'function') {
        const cartHtml = await window.MinimogTheme.Cart.fetchCartSection();
        window.MinimogTheme.Cart.renderNewCart(cartHtml);
      }
      scheduleAdjustDrawerPrices(100);
    } catch (e) {
      console.warn('[CutDown] Cart sync error:', e);
    } finally {
      isSyncingCart = false;
    }
  }

  /* =========================================================================
     LIVE CART DRAWER PRICE ADJUSTER (Instant UI update & failsafe)
     ========================================================================= */
  let isAdjustingPrices = false;
  let adjustTimeout = null;

  function scheduleAdjustDrawerPrices(delay = 50) {
    if (adjustTimeout) clearTimeout(adjustTimeout);
    adjustTimeout = setTimeout(adjustCartDrawerPrices, delay);
  }

  function adjustCartDrawerPrices() {
    if (isAdjustingPrices) return;
    isAdjustingPrices = true;

    try {
      const items = document.querySelectorAll('.scd-item, [data-cart-item]');
      items.forEach((itemEl) => {
        // 1. Hide cut & cap sheet service rows
        const itemTitle = (itemEl.querySelector('a[data-role="product-title"], .scd-item__info a') || {}).textContent || '';
        const isServiceAddon =
          itemEl.dataset.productId === '10319994421384' ||
          itemEl.dataset.productId === '10321079468168' ||
          itemEl.hasAttribute('data-cut-addon-item') ||
          itemEl.classList.contains('scd-item--cut-addon') ||
          itemTitle.toLowerCase().includes('custom roll cut') ||
          itemTitle.toLowerCase().includes('cap sheet');

        if (isServiceAddon) {
          if (itemEl.style.display !== 'none') {
            itemEl.style.setProperty('display', 'none', 'important');
          }
          return;
        }

        // 2. Check if this roll has Cut-Down Size or Cap Sheet Removal property
        const propEls = itemEl.querySelectorAll('[data-cart-item-property], .scd-item__variant-option');
        let hasCut = false;
        let hasCapSheet = false;
        propEls.forEach((p) => {
          const text = (p.textContent || '').toLowerCase();
          if (text.includes('cut-down') || text.includes('cut option') || text.includes('cut size')) {
            hasCut = true;
          }
          if (text.includes('cap sheet')) {
            hasCapSheet = true;
          }
        });

        const addedFee = (hasCut ? 50 : 0) + (hasCapSheet ? 50 : 0);

        if (addedFee > 0) {
          // If Liquid template already added the fee to this roll's price, NEVER add it again in JS!
          const alreadyIncluded =
            itemEl.dataset.cutPriceIncluded === 'true' ||
            itemEl.hasAttribute('data-cut-price-included') ||
            itemEl.querySelector('[data-cut-included="true"]');

          if (!alreadyIncluded) {
            const priceEls = itemEl.querySelectorAll('.scd-item__price, .scd-item__original-price');
            priceEls.forEach((priceEl) => {
              if (priceEl.dataset.cutIncluded === 'true' || priceEl.dataset.cutAdjusted === 'true') return;

              const text = priceEl.textContent.trim();
              const match = text.match(/([\$\£\€]?)\s*([\d,]+(?:\.\d{2})?)/);
              if (match) {
                const currencySymbol = match[1] || '$';
                const num = parseFloat(match[2].replace(/,/g, ''));
                const newPrice = (num + addedFee).toFixed(2);
                priceEl.innerHTML = currencySymbol + newPrice;
                priceEl.dataset.cutAdjusted = 'true';
              }
            });
            itemEl.dataset.cutPriceIncluded = 'true';
          }

          // Ensure proper fee notice is displayed
          let noticeText = '';
          if (hasCut && hasCapSheet) {
            noticeText = '(Includes $50 cut fee + $50 cap sheet removal)';
          } else if (hasCut) {
            noticeText = '(Includes $50 cut fee)';
          } else if (hasCapSheet) {
            noticeText = '(Includes $50 cap sheet removal)';
          }

          let notice = itemEl.querySelector('.cut-fee-included-notice');
          if (!notice) {
            const pricesContainer = itemEl.querySelector('.scd-item__prices');
            if (pricesContainer) {
              notice = document.createElement('span');
              notice.className = 'cut-fee-included-notice block text-xs mt-0.5';
              notice.style.color = '#9ca3af';
              notice.style.fontSize = '11px';
              notice.textContent = noticeText;
              pricesContainer.appendChild(notice);
            }
          } else if (notice.textContent !== noticeText) {
            notice.textContent = noticeText;
          }
        }
      });
    } catch (e) {
      console.warn('[CutDown] adjustCartDrawerPrices error:', e);
    } finally {
      isAdjustingPrices = false;
    }
  }

  // Listen to cart events and cart drawer user actions safely
  if (window.MinimogEvents) {
    window.MinimogEvents.subscribe('ON_CART_UPDATE', () => {
      scheduleAdjustDrawerPrices(50);
      setTimeout(syncCutAddonCart, 250);
    });
    window.MinimogEvents.subscribe('ON_ITEM_ADDED', () => {
      scheduleAdjustDrawerPrices(50);
    });
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-cart-drawer], .sf-cart-icon, .scd__close, .scd-item__remove, .scd-item__btn, [data-qty-change]')) {
      scheduleAdjustDrawerPrices(100);
      setTimeout(syncCutAddonCart, 400);
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('.scd-item__qty_input, input[name="updates[]"]')) {
      scheduleAdjustDrawerPrices(100);
      setTimeout(syncCutAddonCart, 400);
    }
  });

  // Observe only the cart drawer container with debouncing (never observe document.body)
  try {
    const cartDrawerEl = document.querySelector('.sf-cart-drawer') || document.querySelector('.scd__wrapper');
    if (cartDrawerEl) {
      const observer = new MutationObserver(() => {
        scheduleAdjustDrawerPrices(100);
      });
      observer.observe(cartDrawerEl, { childList: true, subtree: true });
    }
  } catch (e) { }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(syncCutAddonCart, 500);
      scheduleAdjustDrawerPrices(200);
    });
  } else {
    setTimeout(syncCutAddonCart, 500);
    scheduleAdjustDrawerPrices(200);
  }
})();
